module.exports = __webpack_public_path__ + "static/media/og_image.a6326898.jpg";